export class LikedQualities {

    email: string = '';
    qualityId: number = 0;
    unityMesureId: number = 0;
    max: number = 0; 
    min: number = 0;
    text: string = '';
    logic: boolean = false;
    status: boolean = false;

    constructor(data?: Partial<LikedQualities>) {
      if (data) {
        Object.assign(this, data);
      }
    }

}